// Get Ready Recommendations: suggests the right bridge course for each child
// on the parent dashboard, based on age band and Grade Placement results.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, ChevronRight } from "lucide-react";
import { api } from "../../lib/api";

export const BridgeRecommendation = () => {
  const [recs, setRecs] = useState([]);

  useEffect(() => {
    api.get("/math/access").then(({ data }) => {
      const kids = data?.math_entitled ? data.children || [] : [];
      if (!kids.length) return;
      Promise.all(kids.map((c) =>
        api.get(`/math-mastery/${c.child_id}/recommendation`)
          .then(({ data: d }) => ({ child: c, ...d }))
          .catch(() => null)))
        .then((out) => setRecs(out.filter((r) => r && r.course_id)));
    }).catch(() => {});
  }, []);

  if (!recs.length) return null;
  return (
    <section className="bg-card rounded-2xl border border-border p-4"
      data-testid="bridge-recommendations">
      <p className="text-sm font-extrabold font-display flex items-center gap-2 mb-2">
        <Award className="h-4 w-4 text-emerald-600" aria-hidden="true" />
        Get Ready recommendations
      </p>
      <div className="space-y-2">
        {recs.map((r) => (
          <Link key={r.child.child_id}
            to={`/math-mastery?track=bridge&course=${r.course_id}`}
            className="flex items-center gap-3 rounded-xl border border-border p-3 hover:border-emerald-400 transition-colors"
            data-testid={`bridge-rec-${r.child.child_id}`}>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-extrabold">
                {r.child.display_name}: <span className="text-emerald-700">{r.label}</span>
              </p>
              <p className="text-[11px] text-muted-foreground">{r.reason}</p>
              {r.points > 0 && (
                <p className="text-[11px] font-bold text-violet-700">
                  {r.points.toLocaleString()} / {r.total_points.toLocaleString()} mastery points so far
                </p>
              )}
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" aria-hidden="true" />
          </Link>
        ))}
      </div>
    </section>
  );
};
